export function createDigestPriorityOpenAction(
  utilisateur = "",
  onOpenConversation
) {
  return {
    href: `/conversations/${encodeURIComponent(utilisateur)}`,
    onClick(event) {
      if (!utilisateur || !onOpenConversation) return;
      event?.preventDefault?.();
      onOpenConversation(utilisateur);
    },
  };
}

export function buildDigestCategoryState(current = null, next = "") {
  return current === next ? null : next;
}

export function buildDigestActiveMetrics(rows = [], doneUtilisateurs = new Set()) {
  const activeRows = rows.filter(
    (row) => row?.utilisateur && !doneUtilisateurs.has(row.utilisateur)
  );

  return {
    conversations: activeRows.length,
    urgent: activeRows.filter((row) => row?.category === "urgent").length,
    booking: activeRows.filter((row) => row?.category === "booking").length,
    admin: activeRows.filter((row) => row?.category === "admin").length,
  };
}
